export var ZeroEtlJobSyncStatus;
(function (ZeroEtlJobSyncStatus) {
    ZeroEtlJobSyncStatus["ZERO_ETL_SYNC_PENDING"] = "PENDING";
    ZeroEtlJobSyncStatus["ZERO_ETL_SYNC_RUNNING"] = "RUNNING";
    ZeroEtlJobSyncStatus["ZERO_ETL_SYNC_COMPLETED"] = "COMPLETED";
    ZeroEtlJobSyncStatus["ZERO_ETL_SYNC_FAILED"] = "FAILED";
    ZeroEtlJobSyncStatus["ZERO_ETL_SYNC_SUPERSEDED"] = "SUPERSEDED";
    ZeroEtlJobSyncStatus["ZERO_ETL_SYNC_SKIPPED_UP_TO_DATE"] = "SKIPPED_UP_TO_DATE";
})(ZeroEtlJobSyncStatus || (ZeroEtlJobSyncStatus = {}));
